import { createElementBlock as l, openBlock as r, createElementVNode as e, computed as d, normalizeClass as u, unref as a, createBlock as $, createCommentVNode as f, resolveDynamicComponent as w, Fragment as g, createTextVNode as x, toDisplayString as M } from "vue";
import { I as z } from "../vendor/@iconify_vue@5.0.0_vue@3.5.18_typescript@5.7.2_.js";
import { i as Z, r as B } from "../utils.js";
import { _ as c } from "../_plugin-vue_export-helper.js";
import { O as F, P as I, Q as y } from "../vendor/lodash-es@4.17.21.js";
const k = {
  name: "Load"
}, A = {
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
};
function H(t, n, o, i, C, s) {
  return r(), l("svg", A, n[0] || (n[0] = [
    e("path", { d: "M23,12.1209038 C23,5.97899823 18.0751322,1 12,1 C5.92486775,1 1,5.97899823 1,12.1209038 C1,15.7482547 2.71777961,18.9699869 5.37578473,21" }, null, -1)
  ]));
}
const S = /* @__PURE__ */ c(k, [["render", H]]), V = {
  name: "Pinned"
}, b = {
  viewBox: "0 0 20 20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
function P(t, n, o, i, C, s) {
  return r(), l("svg", b, n[0] || (n[0] = [
    e("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M13.9207 3.17745C13.9636 2.59765 13.5048 2.10358 12.9234 2.10358H7.07705C6.49567 2.10358 6.03684 2.59765 6.07979 3.17745L6.38753 7.33205C6.40948 7.6283 6.29857 7.91898 6.08486 8.12532L4.78105 9.38418C4.13403 10.0089 4.57626 11.1036 5.47564 11.1036H6.66691H9.00024V16.6894C9.00024 16.9546 9.1056 17.2089 9.29313 17.3965L9.64669 17.75C9.84195 17.9453 10.1585 17.9453 10.3538 17.75L10.7073 17.3965C10.8949 17.2089 11.0002 16.9546 11.0002 16.6894V11.1036H13.3336H14.5248C15.4242 11.1036 15.8665 10.0089 15.2194 9.38418L13.9156 8.12532C13.7019 7.91898 13.591 7.6283 13.6129 7.33205L13.9207 3.17745Z"
    }, null, -1)
  ]));
}
const R = /* @__PURE__ */ c(V, [["render", P]]), N = {
  name: "Restore"
}, D = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function E(t, n, o, i, C, s) {
  return r(), l("svg", D, n[0] || (n[0] = [
    e("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M16.8402 11.5063C16.9401 11.026 17 10.5257 17 10.0053C17 8.39426 16.4608 6.91328 15.5321 5.73249C15.4738 5.65454 15.4112 5.58081 15.3499 5.50856L15.3499 5.50851C15.3168 5.46947 15.284 5.43087 15.2525 5.39226L15.2525 5.39225L15.2525 5.39225L15.2525 5.39224L15.2525 5.39223L15.2525 5.39223C15.1526 5.28216 15.0528 5.1721 14.9429 5.06204C14.8431 4.96197 14.7332 4.86191 14.6234 4.76184C14.4037 4.56171 14.1641 4.38159 13.9244 4.21147C13.9194 4.21147 13.9144 4.20897 13.9094 4.20647C13.9044 4.20397 13.8994 4.20147 13.8944 4.20147C13.7846 4.12141 13.6648 4.05137 13.5449 3.98132C13.4517 3.92128 13.3585 3.87014 13.2653 3.81899L13.2653 3.81896C13.2187 3.79339 13.1721 3.76783 13.1255 3.74116C13.084 3.72012 13.042 3.70085 13.0007 3.68186C12.9438 3.6557 12.888 3.63006 12.8359 3.60107C12.7694 3.57607 12.7029 3.54933 12.6356 3.5223L12.6356 3.52229L12.6356 3.52228L12.6355 3.52225C12.5413 3.48439 12.4457 3.44596 12.3466 3.41094C12.127 3.33089 11.8973 3.26084 11.6576 3.21081C11.6147 3.1936 11.5644 3.18379 11.5194 3.17501L11.4979 3.17078C11.368 3.14076 11.2282 3.11074 11.0984 3.10073L11.0984 3.10073C10.9686 3.08072 10.8388 3.06071 10.709 3.0507C10.6828 3.04545 10.6566 3.04295 10.6289 3.04032L10.6289 3.04032C10.6039 3.03794 10.5777 3.03544 10.5492 3.03069H10.5193C10.4766 3.03069 10.434 3.02339 10.3851 3.01502L10.3595 3.01067H10.3395C10.3102 3.01067 10.2779 3.01315 10.2454 3.01565C10.2127 3.01816 10.1799 3.02068 10.1498 3.02068C9.83024 3.01067 9.5107 3.01067 9.19116 3.0507C9.15121 3.0507 9.11127 3.06071 9.07133 3.07071C8.71184 3.11074 8.34237 3.18079 7.99287 3.29086C7.42368 3.46097 6.88445 3.70113 6.37518 4.00133C6.31526 4.04136 6.25285 4.08139 6.19044 4.12142C6.12803 4.16144 6.06562 4.20147 6.00571 4.24149C5.76605 4.41161 5.53738 4.59173 5.31669 4.79186C5.20685 4.89193 5.097 4.99199 4.99715 5.10207V3.00067C4.99715 2.73049 4.8873 2.48032 4.70756 2.29019C4.51783 2.10007 4.2582 2 3.99857 2C3.72896 2 3.47932 2.10007 3.29058 2.29019C3.09986 2.48032 3 2.73049 3 3.00067V8.004C3 8.19413 3.04993 8.37425 3.1398 8.52435C3.17974 8.5944 3.22967 8.65444 3.29058 8.71448C3.47932 8.9046 3.72896 9.00467 3.99857 9.00467H8.99144C9.25107 9.00467 9.5107 8.9046 9.70043 8.71448C9.88017 8.52435 9.99001 8.27418 9.99001 8.004C9.99001 7.73382 9.88017 7.48366 9.70043 7.29353C9.5107 7.1034 9.25107 7.00334 8.99144 7.00334H5.99572C6.53595 6.28286 7.26391 5.71248 8.10271 5.37225C8.94151 5.03202 9.85021 4.92195 10.7489 5.06204C10.6191 5.03202 10.4793 5.01201 10.3395 5.002C11.418 5.07205 12.3966 5.48232 13.1755 6.15277L13.1954 6.17278C13.2214 6.19529 13.2472 6.21676 13.2725 6.23787L13.2726 6.23792L13.2728 6.23805L13.2729 6.23816L13.273 6.2382C13.3263 6.28266 13.3778 6.32549 13.4251 6.37292C13.515 6.44296 13.5949 6.52302 13.6648 6.61308C13.9315 6.89606 14.1626 7.20648 14.3539 7.54147C14.4957 7.7922 14.6157 8.05552 14.7105 8.32986C14.7181 8.3539 14.7276 8.37794 14.7383 8.40198C14.7507 8.43921 14.7626 8.47667 14.7742 8.51434C14.7742 8.51434 14.7832 8.52435 14.7742 8.53436C14.923 9.00467 15.0029 9.495 15.0029 10.0053C15.0029 10.3456 14.9729 10.6858 14.903 11.006C14.4437 13.2975 12.4165 15.0287 9.99001 15.0287C9.14123 15.0287 8.35235 14.8185 7.65335 14.4283C7.54351 14.3883 7.44365 14.3282 7.34379 14.2482C7.15407 14.1381 6.97432 14.008 6.80456 13.8579C6.63481 13.7278 6.48502 13.5777 6.33524 13.4176C6.23538 13.3276 6.15549 13.2275 6.08559 13.1274L5.90585 12.8873C5.89587 12.8723 5.88528 12.8573 5.87468 12.8423L5.87464 12.8422C5.84281 12.7972 5.81098 12.7522 5.79601 12.7071C5.64622 12.497 5.52639 12.2769 5.43652 12.0467C5.40564 11.9925 5.38073 11.9324 5.35717 11.8755L5.35716 11.8755L5.35716 11.8755L5.35715 11.8755C5.35025 11.8588 5.34345 11.8424 5.33666 11.8266C5.32503 11.7955 5.3119 11.7644 5.29902 11.7339C5.27871 11.6859 5.25901 11.6393 5.24679 11.5964C5.20685 11.4963 5.14693 11.4163 5.07703 11.3362C4.99715 11.2362 4.8873 11.1561 4.76748 11.1061C4.64765 11.046 4.51783 11.016 4.38802 11.006C4.2582 10.996 4.12839 11.016 4.00856 11.066C3.87874 11.1061 3.7689 11.1761 3.66904 11.2662C3.56919 11.3462 3.4893 11.4563 3.43937 11.5764C3.37946 11.6965 3.3495 11.8266 3.33951 11.9566C3.32953 12.0867 3.3495 12.2168 3.39943 12.3369C3.63909 13.0374 3.99857 13.6978 4.44793 14.2782C4.50669 14.3558 4.5688 14.4293 4.62965 14.5013C4.6629 14.5406 4.69578 14.5795 4.72753 14.6184L4.72755 14.6184C4.8274 14.7285 4.92725 14.8386 5.03809 14.9486C5.13694 15.0487 5.24677 15.1487 5.3566 15.2488L5.35663 15.2488C5.57632 15.449 5.81598 15.6291 6.05563 15.7992C6.06063 15.7992 6.06562 15.8017 6.07061 15.8042C6.07561 15.8067 6.0806 15.8092 6.08559 15.8092C6.19544 15.8893 6.31526 15.9593 6.43509 16.0294C6.52829 16.0894 6.62149 16.1405 6.71469 16.1917C6.76129 16.2173 6.80789 16.2428 6.85449 16.2695C6.8951 16.2899 6.9357 16.3085 6.97563 16.3269C7.03391 16.3538 7.09075 16.3799 7.14408 16.4096C7.21062 16.4346 7.27716 16.4614 7.34443 16.4884L7.34444 16.4884L7.34445 16.4884L7.34447 16.4884L7.34448 16.4884C7.4387 16.5263 7.53434 16.5647 7.63338 16.5997C7.85307 16.6798 8.08274 16.7498 8.3224 16.7999C8.36533 16.8171 8.41565 16.8269 8.46066 16.8357L8.48217 16.8399C8.61198 16.8699 8.75178 16.8999 8.8816 16.9099L8.88164 16.9099L8.88165 16.9099C9.01145 16.93 9.14124 16.95 9.26106 16.96C9.32097 16.97 9.38088 16.98 9.43081 16.98H9.46077C9.52068 16.98 9.57061 16.99 9.62054 17H9.64051C9.66932 17 9.69812 16.9977 9.72803 16.9953C9.76034 16.9927 9.79395 16.99 9.83024 16.99C10.1398 17 10.4593 17 10.7799 16.96C10.812 16.96 10.8449 16.9532 10.8834 16.9452L10.9087 16.94C11.0785 16.9199 11.2582 16.8899 11.428 16.8599C11.4379 16.8599 11.4479 16.8574 11.4579 16.8549C11.4679 16.8524 11.4779 16.8499 11.4879 16.8499L11.5679 16.83L11.568 16.83C11.7036 16.7963 11.8439 16.7616 11.9772 16.7198C12.0471 16.6948 12.117 16.6723 12.1869 16.6498C12.2568 16.6273 12.3267 16.6047 12.3966 16.5797C12.5364 16.5297 12.6762 16.4696 12.816 16.4096C13.0856 16.2895 13.3452 16.1594 13.5949 16.0093C13.9743 15.7792 14.3338 15.509 14.6633 15.2188C14.7742 15.1187 14.883 15.0187 14.9829 14.9086V14.9286C15.8916 13.998 16.5506 12.8272 16.8402 11.5063ZM6.34027 13.4101C6.23927 13.3201 6.15927 13.2201 6.09027 13.1201C6.11674 13.1519 6.14573 13.1836 6.17472 13.2154L6.17473 13.2154L6.17477 13.2155C6.20052 13.2437 6.22628 13.2719 6.25027 13.3001C6.26548 13.3211 6.28124 13.3393 6.29712 13.3577L6.29713 13.3577C6.31152 13.3743 6.32601 13.3911 6.34027 13.4101ZM11.4054 5.20415L11.4054 5.20415L11.3902 5.19965L11.4809 5.22741C11.456 5.2191 11.4307 5.21161 11.4054 5.20415ZM12.9643 5.98729C12.6175 5.73028 12.2431 5.51682 11.8473 5.3573C12.2486 5.51771 12.6231 5.72847 12.9643 5.98729ZM11.8473 5.3573C11.7272 5.3089 11.6052 5.26547 11.4813 5.22729C11.6056 5.26611 11.7276 5.30947 11.8473 5.3573ZM13.9399 4.20998C13.9349 4.20998 13.9299 4.20748 13.9249 4.20498C13.9199 4.20248 13.9149 4.19998 13.9099 4.19998C13.7999 4.11998 13.6799 4.04998 13.5599 3.97998C13.6899 4.04998 13.8199 4.12998 13.9399 4.20998Z",
      fill: "currentColor"
    }, null, -1)
  ]));
}
const U = /* @__PURE__ */ c(N, [["render", E]]), j = {
  name: "DotsMove"
}, T = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function q(t, n, o, i, C, s) {
  return r(), l("svg", T, n[0] || (n[0] = [
    e("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7 17C7.5515 17 8 17.4485 8 18C8 18.5515 7.5515 19 7 19C6.4485 19 6 18.5515 6 18C6 17.4485 6.4485 17 7 17ZM12 17C12.5515 17 13 17.4485 13 18C13 18.5515 12.5515 19 12 19C11.4485 19 11 18.5515 11 18C11 17.4485 11.4485 17 12 17ZM7 12C7.5515 12 8 12.4485 8 13C8 13.5515 7.5515 14 7 14C6.4485 14 6 13.5515 6 13C6 12.4485 6.4485 12 7 12ZM12 12C12.5515 12 13 12.4485 13 13C13 13.5515 12.5515 14 12 14C11.4485 14 11 13.5515 11 13C11 12.4485 11.4485 12 12 12ZM7 7C7.5515 7 8 7.4485 8 8C8 8.5515 7.5515 9 7 9C6.4485 9 6 8.5515 6 8C6 7.4485 6.4485 7 7 7ZM12 7C12.5515 7 13 7.4485 13 8C13 8.5515 12.5515 9 12 9C11.4485 9 11 8.5515 11 8C11 7.4485 11.4485 7 12 7ZM7 2C7.5515 2 8 2.4485 8 3C8 3.5515 7.5515 4 7 4C6.4485 4 6 3.5515 6 3C6 2.4485 6.4485 2 7 2ZM12 2C12.5515 2 13 2.4485 13 3C13 3.5515 12.5515 4 12 4C11.4485 4 11 3.5515 11 3C11 2.4485 11.4485 2 12 2Z",
      fill: "currentColor"
    }, null, -1)
  ]));
}
const G = /* @__PURE__ */ c(j, [["render", q]]), O = {
  name: "CheckSquare"
}, J = {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1",
  stroke: "none",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function W(t, n, o, i, C, s) {
  return r(), l("svg", J, n[0] || (n[0] = [
    e("path", { d: "M10,0 C10.55,0 11,0.45 11,1 C11,1.55 10.55,2 10,2 L10,2 L3,2 C2.4,2 2,2.4 2,3 L2,3 L2,15 C2,15.6 2.4,16 3,16 L3,16 L15,16 C15.6,16 16,15.6 16,15 L16,15 L16,12.96 C16,12.43 16.43,12 16.96,12 L16.96,12 L17.04,12 C17.57,12 18,12.43 18,12.96 L18,12.96 L18,15 C18,16.7 16.7,18 15,18 L15,18 L3,18 C1.3,18 0,16.7 0,15 L0,15 L0,3 C0,1.3 1.3,0 3,0 L3,0 Z M19.293,1.2773 C19.684,0.8863 20.317,0.8863 20.707,1.2773 C21.099,1.6683 21.099,2.3003 20.707,2.6913 L20.707,2.6913 L12.707,10.6913 C12.317,11.0823 11.684,11.0823 11.293,10.6913 L11.293,10.6913 L7.293,6.6913 C6.902,6.3003 6.902,5.6683 7.293,5.2773 C7.684,4.8863 8.317,4.8863 8.707,5.2773 L8.707,5.2773 L12,8.5703 Z" }, null, -1)
  ]));
}
const K = /* @__PURE__ */ c(O, [["render", W]]), Q = {
  name: "Timer"
}, X = {
  fill: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
function Y(t, n, o, i, C, s) {
  return r(), l("svg", X, n[0] || (n[0] = [
    e("path", {
      transform: "translate(4.000000, 2.000000)",
      "fill-rule": "evenodd",
      d: "M16,0 C16.5522847,-1.01453063e-16 17,0.44771525 17,1 C17,1.55228475 16.5522847,2 16,2 L15.862925,2.00094551 C15.2879731,6.08369464 13.0096314,8.68277391 11.0437178,9.98762061 C13.0213234,11.2830593 15.2949601,13.8897599 15.8650982,18.000056 L16,18 C16.5522847,18 17,18.4477153 17,19 C17,19.5128358 16.6139598,19.9355072 16.1166211,19.9932723 L16,20 L1,20 C0.44771525,20 6.76353751e-17,19.5522847 0,19 C-6.76353751e-17,18.4477153 0.44771525,18 1,18 L1.12929698,17.9993641 C1.68455514,13.8320396 3.92807612,11.2637718 5.89848876,9.98715007 C3.9394017,8.70237278 1.69132355,6.14087886 1.13138232,2.001638 L1,2 C0.44771525,2 6.76353751e-17,1.55228475 0,1 C-6.76353751e-17,0.44771525 0.44771525,1.01453063e-16 1,0 L16,0 Z M8.5,11 C7.97874027,11 6.6108169,11.7257018 5.50387188,12.9248748 L5.50387188,12.9248748 L5.31125967,13.1405797 C4.23865984,14.3825163 3.48896932,15.9577126 3.17081999,17.8615545 L3.17081999,17.8615545 L3.149,18 L13.841,18 L13.8136286,17.8233935 C13.4667202,15.8808144 12.6501456,14.2611268 11.4873667,12.9849712 C10.3685028,11.7570124 8.98915963,11 8.5,11 Z M13.839,2 L3.152,2 L3.17273281,2.13232361 C3.49445337,4.03174829 4.25259646,5.60656037 5.33752199,6.85356538 L5.53234933,7.0702216 C6.64343394,8.26583763 8.02009884,9 8.5,9 C8.94776467,9 10.3361583,8.23403171 11.4588525,7.01010119 C12.6350085,5.72788812 13.460763,4.10831033 13.8115507,2.17025057 L13.839,2 Z"
    }, null, -1)
  ]));
}
const n1 = /* @__PURE__ */ c(Q, [["render", Y]]), e1 = {
  name: "Branch"
}, t1 = {
  fill: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
function o1(t, n, o, i, C, s) {
  return r(), l("svg", t1, n[0] || (n[0] = [
    e("path", {
      "fill-rule": "evenodd",
      d: "M12,2 C14.209139,2 16,3.790861 16,6 C16,7.86356525 14.7256022,9.42947895 13.0007613,9.87378648 L13,10.922 L15.0074175,10.9275223 L15.1833735,10.9330331 C16.7552796,11.0278628 18,12.3326248 18,13.9275132 L18,13.9275132 L18.0007613,14.1262135 C19.7256022,14.570521 21,16.1364348 21,18 C21,20.209139 19.209139,22 17,22 C14.790861,22 13,20.209139 13,18 C13,16.1360729 14.2748927,14.5699129 16.0002435,14.1259548 L16,13.9275132 L15.9932946,13.8110898 C15.9357195,13.3145669 15.5144104,12.928782 15.0024725,12.9275162 L15.0024725,12.9275162 L12,12.92 L8.99752751,12.9275162 C8.4855896,12.928782 8.06428052,13.3145669 8.00670543,13.8110898 L8,13.9275132 L8.00076134,14.1262135 C9.72560224,14.570521 11,16.1364348 11,18 C11,20.209139 9.209139,22 7,22 C4.790861,22 3,20.209139 3,18 C3,16.1360729 4.27489272,14.5699129 6.00024347,14.1259548 L6,13.9275132 C6,12.3326248 7.24472035,11.0278628 8.81662646,10.9330331 L8.99258252,10.9275223 L11,10.922 L11.0002435,9.87404517 C9.27489272,9.43008706 8,7.86392711 8,6 C8,3.790861 9.790861,2 12,2 Z M17,16 C15.8954305,16 15,16.8954305 15,18 C15,19.1045695 15.8954305,20 17,20 C18.1045695,20 19,19.1045695 19,18 C19,16.8954305 18.1045695,16 17,16 Z M7,16 C5.8954305,16 5,16.8954305 5,18 C5,19.1045695 5.8954305,20 7,20 C8.1045695,20 9,19.1045695 9,18 C9,16.8954305 8.1045695,16 7,16 Z M12,4 C10.8954305,4 10,4.8954305 10,6 C10,7.1045695 10.8954305,8 12,8 C13.1045695,8 14,7.1045695 14,6 C14,4.8954305 13.1045695,4 12,4 Z"
    }, null, -1)
  ]));
}
const r1 = /* @__PURE__ */ c(e1, [["render", o1]]), s1 = {
  name: "Token"
}, l1 = {
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function i1(t, n, o, i, C, s) {
  return r(), l("svg", l1, n[0] || (n[0] = [
    e("path", { d: "M2,5 C2,4.47 2.2107,3.961 2.5858,3.586 C2.9609,3.211 3.4696,3 4,3 L16,3 C16.53,3 17.039,3.211 17.414,3.586 C17.789,3.961 18,4.47 18,5 L18,15 C18,15.53 17.789,16.039 17.414,16.414 C17.039,16.789 16.53,17 16,17 L4,17 C3.4696,17 2.9609,16.789 2.5858,16.414 C2.2107,16.039 2,15.53 2,15 L2,5 Z" }, null, -1),
    e("path", {
      id: "Path",
      d: "M5.293,6.293 C5.4805,6.106 5.7348,6 6,6 C6.2652,6 6.5195,6.106 6.707,6.293 L9.707,9.293 C9.8945,9.481 9.9998,9.735 9.9998,10 C9.9998,10.265 9.8945,10.519 9.707,10.707 L6.707,13.707 C6.5184,13.889 6.2658,13.99 6.0036,13.9880291 C5.7414,13.985 5.4906,13.88 5.3052,13.695 C5.1198,13.509 5.0146,13.259 5.0123,12.996 C5.01,12.734 5.1108,12.482 5.293,12.293 L7.586,10 L5.293,7.707 C5.1055,7.519 5.0002,7.265 5.0002,7 C5.0002,6.735 5.1055,6.481 5.293,6.293 Z",
      fill: "#FFFFFF"
    }, null, -1),
    e("path", {
      id: "Path",
      d: "M11,12 C10.735,12 10.48,12.105 10.293,12.293 C10.105,12.48 10,12.735 10,13 C10,13.265 10.105,13.52 10.293,13.707 C10.48,13.895 10.735,14 11,14 L14,14 C14.265,14 14.52,13.895 14.707,13.707 C14.895,13.52 15,13.265 15,13 C15,12.735 14.895,12.48 14.707,12.293 C14.52,12.105 14.265,12 14,12 L11,12 Z",
      fill: "#FFFFFF"
    }, null, -1)
  ]));
}
const C1 = /* @__PURE__ */ c(s1, [["render", i1]]), c1 = {
  name: "Number"
}, a1 = {
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function d1(t, n, o, i, C, s) {
  return r(), l("svg", a1, n[0] || (n[0] = [
    e("rect", {
      id: "Rectangle",
      x: "2",
      y: "2",
      width: "16",
      height: "16",
      rx: "2"
    }, null, -1),
    e("path", {
      id: "Combined-Shape",
      d: "M10,5 C10.5522847,5 11,5.44771525 11,6 L10.9990817,13 L12,13 C12.5522847,13 13,13.4477153 13,14 C13,14.5522847 12.5522847,15 12,15 L8,15 C7.44771525,15 7,14.5522847 7,14 C7,13.4477153 7.44771525,13 8,13 L8.99908174,13 L8.99908174,8.198 L8.35987154,8.83972749 C7.98092135,9.21938514 7.3659482,9.21995865 6.98629055,8.84100847 L6.98497428,8.83969212 C6.60510373,8.45907323 6.60511958,7.84275653 6.98500972,7.46215718 L9.14096077,5.30218118 C9.32736744,5.11542651 9.57088421,5.02039822 9.81541005,5.01714863 C9.87499267,5.00586065 9.93681192,5 10,5 Z",
      fill: "#FFFFFF"
    }, null, -1)
  ]));
}
const u1 = /* @__PURE__ */ c(c1, [["render", d1]]), p1 = {
  name: "Dot"
}, $1 = {
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
function f1(t, n, o, i, C, s) {
  return r(), l("svg", $1, n[0] || (n[0] = [
    e("rect", {
      x: "10",
      y: "10",
      width: "4",
      height: "4",
      rx: "1"
    }, null, -1)
  ]));
}
const _1 = /* @__PURE__ */ c(p1, [["render", f1]]), h1 = {
  name: "Percent"
}, v1 = {
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function L1(t, n, o, i, C, s) {
  return r(), l("svg", v1, n[0] || (n[0] = [
    e("path", {
      d: "M14.4817273,0.502364881 C14.9395921,0.811198594 15.0604056,1.43273055 14.7515719,1.89059536 L4.68609967,16.8132717 C4.37726595,17.2711365 3.755734,17.39195 3.29786919,17.0831163 C2.84000438,16.7742826 2.71919081,16.1527507 3.02802452,15.6948859 L13.0934968,0.77220955 C13.4023305,0.314344742 14.0238625,0.193531169 14.4817273,0.502364881 Z M14,9 C16.209139,9 18,10.790861 18,13 C18,15.209139 16.209139,17 14,17 C11.790861,17 10,15.209139 10,13 C10,10.790861 11.790861,9 14,9 Z M14,11 C12.8954305,11 12,11.8954305 12,13 C12,14.1045695 12.8954305,15 14,15 C15.1045695,15 16,14.1045695 16,13 C16,11.8954305 15.1045695,11 14,11 Z M4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 Z M4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 Z",
      "fill-rule": "nonzero"
    }, null, -1)
  ]));
}
const m1 = /* @__PURE__ */ c(h1, [["render", L1]]), w1 = {
  name: "Wave"
}, g1 = {
  transform: "rotate(-45)",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
function x1(t, n, o, i, C, s) {
  return r(), l("svg", g1, n[0] || (n[0] = [
    e("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M7 11.5V14m0-2.5v-6a1.5 1.5 0 113 0m-3 6a1.5 1.5 0 00-3 0v2a7.5 7.5 0 0015 0v-5a1.5 1.5 0 00-3 0m-6-3V11m0-5.5v-1a1.5 1.5 0 013 0v1m0 0V11m0-5.5a1.5 1.5 0 013 0v3m0 0V11"
    }, null, -1)
  ]));
}
const M1 = /* @__PURE__ */ c(w1, [["render", x1]]), z1 = {
  name: "Checkbox"
}, Z1 = {
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function B1(t, n, o, i, C, s) {
  return r(), l("svg", Z1, n[0] || (n[0] = [
    e("rect", {
      id: "Rectangle-Copy-48",
      x: "0",
      y: "0",
      width: "20",
      height: "20",
      fill: "none"
    }, null, -1),
    e("path", {
      id: "Shape",
      d: "M4,2 L16,2 C17.1045695,2 18,2.8954305 18,4 L18,16 C18,17.1045695 17.1045695,18 16,18 L4,18 C2.8954305,18 2,17.1045695 2,16 L2,4 C2,2.8954305 2.8954305,2 4,2 Z M13.707,8.707 C13.889,8.5184 13.99,8.2658 13.9880291,8.0036 C13.985,7.7414 13.88,7.4906 13.695,7.3052 C13.509,7.1198 13.259,7.0146 12.996,7.01226149 C12.734,7.01 12.482,7.1108 12.293,7.293 L9,10.586 L7.707,9.293 C7.518,9.1108 7.266,9.01 7.004,9.0123 C6.741,9.0146 6.491,9.1198 6.305,9.3052 C6.12,9.4906 6.015,9.7414 6.01197085,10.0036 C6.01,10.2658 6.111,10.5184 6.293,10.707 L8.293,12.707 C8.481,12.8945 8.735,12.9998 9,12.9998 C9.265,12.9998 9.519,12.8945 9.707,12.707 L13.707,8.707 Z"
    }, null, -1)
  ]));
}
const F1 = /* @__PURE__ */ c(z1, [["render", B1]]), I1 = {
  name: "Multiline"
}, y1 = {
  fill: "currentColor",
  stroke: "currentColor",
  viewBox: "0 0 20 20"
};
function k1(t, n, o, i, C, s) {
  return r(), l("svg", y1, n[0] || (n[0] = [
    e("rect", {
      "stroke-width": "2",
      x: "3",
      y: "3",
      width: "14",
      height: "14",
      rx: "2"
    }, null, -1),
    e("rect", {
      stroke: "#FFFFFF",
      "stroke-width": "2",
      fill: "#FFFFFF",
      x: "5",
      y: "6",
      width: "6",
      height: "1",
      rx: "0.5"
    }, null, -1),
    e("rect", {
      stroke: "#FFFFFF",
      "stroke-width": "2",
      fill: "#FFFFFF",
      x: "5",
      y: "10",
      width: "10",
      height: "1",
      rx: "0.5"
    }, null, -1),
    e("rect", {
      stroke: "#FFFFFF",
      "stroke-width": "2",
      fill: "#FFFFFF",
      x: "5",
      y: "14",
      width: "6",
      height: "1",
      rx: "0.5"
    }, null, -1)
  ]));
}
const A1 = /* @__PURE__ */ c(I1, [["render", k1]]), H1 = {
  name: "RadioCircle"
}, S1 = {
  fill: "currentColor",
  viewBox: "0 0 20 20",
  "fill-rule": "evenodd"
};
function V1(t, n, o, i, C, s) {
  return r(), l("svg", S1, n[0] || (n[0] = [
    e("rect", {
      id: "Rectangle-Copy-48",
      x: "0",
      y: "0",
      width: "20",
      height: "20",
      fill: "none"
    }, null, -1),
    e("path", {
      id: "Shape",
      d: "M10,18 C12.122,18 14.157,17.1571 15.657,15.6569 C17.157,14.1566 18,12.1217 18,10 C18,7.8783 17.157,5.8434 15.657,4.3431 C14.157,2.8429 12.122,2 10,2 C7.878,2 5.843,2.8429 4.343,4.3431 C2.843,5.8434 2,7.8783 2,10 C2,12.1217 2.843,14.1566 4.343,15.6569 C5.843,17.1571 7.878,18 10,18 Z M10,13 C11.6568542,13 13,11.6568542 13,10 C13,8.34314575 11.6568542,7 10,7 C8.34314575,7 7,8.34314575 7,10 C7,11.6568542 8.34314575,13 10,13 Z"
    }, null, -1)
  ]));
}
const b1 = /* @__PURE__ */ c(H1, [["render", V1]]), P1 = {
  name: "Signature"
}, R1 = {
  fill: "none",
  viewBox: "0 0 20 20"
};
function N1(t, n, o, i, C, s) {
  return r(), l("svg", R1, n[0] || (n[0] = [
    e("path", {
      d: "M13.5858 3.58579C14.3668 2.80474 15.6332 2.80474 16.4142 3.58579C17.1953 4.36683 17.1953 5.63316 16.4142 6.41421L15.6213 7.20711L12.7929 4.37868L13.5858 3.58579Z",
      fill: "currentColor"
    }, null, -1),
    e("path", {
      d: "M11.3787 5.79289L3 14.1716V17H5.82842L14.2071 8.62132L11.3787 5.79289Z",
      fill: "currentColor"
    }, null, -1),
    e("path", {
      d: "M9.75 15H16.75C17.3023 15 17.75 15.4477 17.75 16V16C17.75 16.5523 17.3023 17 16.75 17H7.75L9.75 15Z",
      fill: "currentColor"
    }, null, -1)
  ]));
}
const D1 = /* @__PURE__ */ c(P1, [["render", N1]]), E1 = {
  name: "Singleline"
}, U1 = {
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function j1(t, n, o, i, C, s) {
  return r(), l("svg", U1, n[0] || (n[0] = [
    e("path", { d: "M11,4 C11.5522847,4 12,4.44771525 12,5 L12,6 C12,6.55228475 11.5522847,7 11,7 C10.4477153,7 10,6.55228475 10,6 L8,6 L8,14 C8.55228475,14 9,14.4477153 9,15 C9,15.5522847 8.55228475,16 8,16 L6,16 C5.44771525,16 5,15.5522847 5,15 C5,14.4477153 5.44771525,14 6,14 L6,6 L4,6 C4,6.55228475 3.55228475,7 3,7 C2.44771525,7 2,6.55228475 2,6 L2,5 C2,4.44771525 2.44771525,4 3,4 L11,4 Z M17.2,14 C17.6418278,14 18,14.4477153 18,15 C18,15.5522847 17.6418278,16 17.2,16 L10,16 C10.4418278,16 10.8,15.5522847 10.8,15 C10.8,14.4871642 10.3978709,14.0577651 10,14 L17.2,14 Z" }, null, -1)
  ]));
}
const T1 = /* @__PURE__ */ c(E1, [["render", j1]]), q1 = {
  name: "Bold"
}, G1 = {
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function O1(t, n, o, i, C, s) {
  return r(), l("svg", G1, n[0] || (n[0] = [
    e("path", { d: "M5,5 C5,4.44771525 5.44771525,4 6,4 L10.5,4 C12.4329966,4 14,5.56700338 14,7.5 C14,8.32575057 13.7140399,9.08471157 13.2357463,9.68325623 C14.2996738,10.4006247 15,11.6185274 15,13 C15,15.209139 13.209139,17 11,17 L6,17 C5.44771525,17 5,16.5522847 5,16 L5,5 Z M11,11 L7,11 L7,15 L11,15 C12.1045695,15 13,14.1045695 13,13 C13,11.9456382 12.1841222,11.0818349 11.1492623,11.0054857 L11,11 Z M10.5,6 L7,6 L7,9 L10.5,9 C11.3284271,9 12,8.32842712 12,7.5 C12,6.72030388 11.4051119,6.07955132 10.64446,6.00686658 L10.5,6 Z" }, null, -1)
  ]));
}
const J1 = /* @__PURE__ */ c(q1, [["render", O1]]), W1 = {
  name: "Italics"
}, K1 = {
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Q1(t, n, o, i, C, s) {
  return r(), l("svg", K1, n[0] || (n[0] = [
    e("path", { d: "M14.4482065,4 C15.0004913,4 15.4482065,4.44771525 15.4482065,5 C15.4482065,5.55228475 15.0004913,6 14.4482065,6 L12.832,6 L9.557,15 L11,15 C11.5522847,15 12,15.4477153 12,16 C12,16.5522847 11.5522847,17 11,17 L6,17 C5.44771525,17 5,16.5522847 5,16 C5,15.4477153 5.44771525,15 6,15 L7.429,15 L10.704,6 L9.4482065,6 C8.89592175,6 8.4482065,5.55228475 8.4482065,5 C8.4482065,4.44771525 8.89592175,4 9.4482065,4 L14.4482065,4 Z" }, null, -1)
  ]));
}
const X1 = /* @__PURE__ */ c(W1, [["render", Q1]]), Y1 = {
  name: "Underline"
}, n5 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function e5(t, n, o, i, C, s) {
  return r(), l("svg", n5, n[0] || (n[0] = [
    e("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M14 16C14.5523 16 15 16.4477 15 17C15 17.5523 14.5523 18 14 18H6C5.44772 18 5 17.5523 5 17C5 16.4477 5.44772 16 6 16H14ZM14 3C14.5128 3 14.9355 3.38604 14.9933 3.88338L15 4V9C15 11.7614 12.7614 14 10 14C7.31125 14 5.11818 11.8777 5.00462 9.21689L5 9V4C5 3.44772 5.44772 3 6 3C6.51284 3 6.93551 3.38604 6.99327 3.88338L7 4V9C7 10.6569 8.34315 12 10 12C11.5977 12 12.9037 10.7511 12.9949 9.17627L13 9V4C13 3.44772 13.4477 3 14 3Z",
      fill: "currentColor"
    }, null, -1)
  ]));
}
const t5 = /* @__PURE__ */ c(Y1, [["render", e5]]), o5 = {
  name: "LeftAlign"
}, r5 = {
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
};
function s5(t, n, o, i, C, s) {
  return r(), l("svg", r5, n[0] || (n[0] = [
    e("path", {
      "clip-rule": "evenodd",
      "fill-rule": "evenodd",
      d: "M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"
    }, null, -1)
  ]));
}
const l5 = /* @__PURE__ */ c(o5, [["render", s5]]), i5 = {
  name: "CenterAlign"
}, C5 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function c5(t, n, o, i, C, s) {
  return r(), l("svg", C5, n[0] || (n[0] = [
    e("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3 5C3 4.44772 3.44772 4 4 4H16C16.5523 4 17 4.44772 17 5C17 5.55228 16.5523 6 16 6H4C3.44772 6 3 5.55228 3 5Z",
      fill: "currentColor"
    }, null, -1),
    e("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6 10C6 9.44772 6.44772 9 7 9H13C13.5523 9 14 9.44772 14 10C14 10.5523 13.5523 11 13 11H7C6.44772 11 6 10.5523 6 10Z",
      fill: "currentColor"
    }, null, -1),
    e("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3 15C3 14.4477 3.44772 14 4 14H16C16.5523 14 17 14.4477 17 15C17 15.5523 16.5523 16 16 16H4C3.44772 16 3 15.5523 3 15Z",
      fill: "currentColor"
    }, null, -1)
  ]));
}
const a5 = /* @__PURE__ */ c(i5, [["render", c5]]), d5 = {
  name: "RightAlign"
}, u5 = {
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
};
function p5(t, n, o, i, C, s) {
  return r(), l("svg", u5, n[0] || (n[0] = [
    e("path", {
      "clip-rule": "evenodd",
      "fill-rule": "evenodd",
      d: "M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm7 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"
    }, null, -1)
  ]));
}
const $5 = /* @__PURE__ */ c(d5, [["render", p5]]), f5 = {
  name: "UnorderedList"
}, _5 = {
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function h5(t, n, o, i, C, s) {
  return r(), l("svg", _5, n[0] || (n[0] = [
    e("path", { d: "M7,5 C7,4.735 7.105,4.48 7.293,4.293 C7.48,4.105 7.735,4 8,4 L16,4 C16.265,4 16.52,4.105 16.707,4.293 C16.895,4.48 17,4.735 17,5 C17,5.265 16.895,5.52 16.707,5.707 C16.52,5.895 16.265,6 16,6 L8,6 C7.735,6 7.48,5.895 7.293,5.707 C7.105,5.52 7,5.265 7,5 Z M7,10 C7,9.735 7.105,9.48 7.293,9.293 C7.48,9.105 7.735,9 8,9 L16,9 C16.265,9 16.52,9.105 16.707,9.293 C16.895,9.48 17,9.735 17,10 C17,10.265 16.895,10.52 16.707,10.707 C16.52,10.895 16.265,11 16,11 L8,11 C7.735,11 7.48,10.895 7.293,10.707 C7.105,10.52 7,10.265 7,10 Z M4,9 C4.55228475,9 5,9.44771525 5,10 C5,10.5522847 4.55228475,11 4,11 C3.44771525,11 3,10.5522847 3,10 C3,9.44771525 3.44771525,9 4,9 Z M4,4 C4.55228475,4 5,4.44771525 5,5 C5,5.55228475 4.55228475,6 4,6 C3.44771525,6 3,5.55228475 3,5 C3,4.44771525 3.44771525,4 4,4 Z M4,14 C4.55228475,14 5,14.4477153 5,15 C5,15.5522847 4.55228475,16 4,16 C3.44771525,16 3,15.5522847 3,15 C3,14.4477153 3.44771525,14 4,14 Z M7,15 C7,14.735 7.105,14.48 7.293,14.293 C7.48,14.105 7.735,14 8,14 L16.000412,14 C16.265412,14 16.520412,14.105 16.707412,14.293 C16.895412,14.48 17.000412,14.735 17.000412,15 C17.000412,15.265 16.895412,15.52 16.707412,15.707 C16.520412,15.895 16.265412,16 16.000412,16 L8,16 C7.735,16 7.48,15.895 7.293,15.707 C7.105,15.52 7,15.265 7,15 Z" }, null, -1)
  ]));
}
const v5 = /* @__PURE__ */ c(f5, [["render", h5]]), L5 = {
  name: "OrderedList"
}, m5 = {
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function w5(t, n, o, i, C, s) {
  return r(), l("svg", m5, n[0] || (n[0] = [
    e("path", { d: "M4.01019105,11 C4.41713894,11 4.76990982,11.0630218 5.0685037,11.1890655 C5.36709758,11.3151092 5.59786681,11.4921323 5.7608114,11.7201349 C5.92375598,11.9481374 6.00522827,12.2154785 6.00522827,12.522158 C6.00522827,12.7116249 5.96469891,12.8998876 5.88364018,13.0869461 C5.80258145,13.2740045 5.76998334,13.368897 5.50868362,13.6728797 C5.33448381,13.8755348 4.94747595,14.2345749 4.34766003,14.75 L4.34766003,14.75 L5.44355095,14.7611375 C5.7849147,14.7646067 6.05981884,15.0423189 6.05981884,15.3837003 C6.05981884,15.7240732 5.78389206,16 5.44351912,16 L5.44351912,16 L2.64076999,16 C2.37473688,16 2.15907442,15.7843375 2.15907442,15.5183044 C2.15907442,15.2137756 2.29722155,14.925688 2.53468016,14.7350281 L2.53468016,14.7350281 L4.05485606,13.5144509 C4.1805798,13.4132948 4.28852025,13.3181599 4.3786774,13.2290462 C4.46883456,13.1399326 4.53831346,13.048009 4.58711413,12.9532755 C4.63591479,12.8585421 4.66031512,12.7533719 4.66031512,12.6377649 C4.66031512,12.5109184 4.63260627,12.4722442 4.57718857,12.3823277 C4.52177087,12.2924112 4.44526135,12.2229668 4.34766003,12.1739944 C4.25005871,12.125022 4.13756905,12.1005358 4.01019105,12.1005358 C3.88281305,12.1005358 3.67551682,12.1005358 3.57717487,12.2532601 C3.55301256,12.2972926 3.53185571,12.3495579 3.51370432,12.4100561 C3.45024873,12.6215521 3.25558047,12.7663868 3.03477016,12.7663605 L3.03477016,12.7663605 L2.52251459,12.7663605 C2.49648796,12.7663605 2.47052345,12.7638202 2.44499033,12.7587758 C2.22827255,12.7159603 2.08729688,12.5055671 2.13009951,12.2888468 C2.17627817,12.0551056 2.23308287,11.8856057 2.30051363,11.7803468 C2.46097682,11.5298651 2.6876104,11.3371869 2.98041437,11.2023121 C3.27321834,11.0674374 3.61647724,11 4.01019105,11 Z M16.1602679,14 C16.3987581,14 16.6282486,14.105 16.7965417,14.293 C16.9657347,14.48 17.0602308,14.735 17.0602308,15 C17.0602308,15.265 16.9657347,15.52 16.7965417,15.707 C16.6282486,15.895 16.3987581,16 16.1602679,16 L8.96019375,16 C8.72170358,16 8.49221303,15.895 8.32391996,15.707 C8.15472693,15.52 8.06023083,15.265 8.06023083,15 C8.06023083,14.735 8.15472693,14.48 8.32391996,14.293 C8.49221303,14.105 8.72170358,14 8.96019375,14 L16.1602679,14 Z M16.1602308,9 C16.3987308,9 16.6282308,9.105 16.7965308,9.293 C16.9657308,9.48 17.0602308,9.735 17.0602308,10 C17.0602308,10.265 16.9657308,10.52 16.7965308,10.707 C16.6282308,10.895 16.3987308,11 16.1602308,11 L8.96023083,11 C8.72173083,11 8.49223083,10.895 8.32393083,10.707 C8.15473083,10.52 8.06023083,10.265 8.06023083,10 C8.06023083,9.735 8.15473083,9.48 8.32393083,9.293 C8.49223083,9.105 8.72173083,9 8.96023083,9 L16.1602308,9 Z M4.39024374,3 C4.54016109,3 4.67857087,3.04926974 4.79016409,3.13250022 C4.8638827,3.17728442 4.93068396,3.23665566 4.98576218,3.30974693 L4.99337111,3.31984431 C5.13842297,3.51233463 5.15602728,3.7611783 5.06040072,3.96521852 L5.05981884,8.3304249 C5.05981884,8.70022102 4.76003986,9 4.39024374,9 C4.02044763,9 3.72066865,8.70022102 3.72066865,8.3304249 L3.71981884,4.958 L3.07819368,5.38104097 C2.76970382,5.58417575 2.35646677,5.51266418 2.134178,5.21767701 L2.12656907,5.20757963 C1.91771275,4.93041794 1.9730852,4.53642249 2.2502469,4.32756617 C2.26086308,4.31956631 2.27173043,4.31190533 2.28283255,4.30459479 L3.85468589,3.26762874 C3.97685327,3.10511058 4.17127356,3 4.39024374,3 Z M16.1602308,4 C16.3987308,4 16.6282308,4.105 16.7965308,4.293 C16.9657308,4.48 17.0602308,4.735 17.0602308,5 C17.0602308,5.265 16.9657308,5.52 16.7965308,5.707 C16.6282308,5.895 16.3987308,6 16.1602308,6 L8.96023083,6 C8.72173083,6 8.49223083,5.895 8.32393083,5.707 C8.15473083,5.52 8.06023083,5.265 8.06023083,5 C8.06023083,4.735 8.15473083,4.48 8.32393083,4.293 C8.49223083,4.105 8.72173083,4 8.96023083,4 L16.1602308,4 Z" }, null, -1)
  ]));
}
const g5 = /* @__PURE__ */ c(L5, [["render", w5]]), x5 = {
  name: "PlusOutline"
}, M5 = {
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
function z5(t, n, o, i, C, s) {
  return r(), l("svg", M5, n[0] || (n[0] = [
    e("path", {
      d: "M12 4V20M20 12L4 12",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const Z5 = /* @__PURE__ */ c(x5, [["render", z5]]), B5 = {
  name: "Plus"
}, F5 = {
  viewBox: "0 0 20 20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
function I5(t, n, o, i, C, s) {
  return r(), l("svg", F5, n[0] || (n[0] = [
    e("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M10.0001 3C10.5524 3 11.0001 3.44772 11.0001 4V9H16.0001C16.5524 9 17.0001 9.44772 17.0001 10C17.0001 10.5523 16.5524 11 16.0001 11H11.0001V16C11.0001 16.5523 10.5524 17 10.0001 17C9.44784 17 9.00012 16.5523 9.00012 16V11H4.00012C3.44784 11 3.00012 10.5523 3.00012 10C3.00012 9.44771 3.44784 9 4.00012 9L9.00012 9V4C9.00012 3.44772 9.44784 3 10.0001 3Z"
    }, null, -1)
  ]));
}
const y5 = /* @__PURE__ */ c(B5, [["render", I5]]), k5 = {
  name: "Ring"
}, A5 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-5 h-5"
};
function H5(t, n, o, i, C, s) {
  return r(), l("svg", A5, n[0] || (n[0] = [
    e("circle", {
      cx: "10",
      cy: "10",
      r: "8",
      stroke: "currentColor"
    }, null, -1)
  ]));
}
const S5 = /* @__PURE__ */ c(k5, [["render", H5]]), V5 = {
  name: "RocketLaunch"
}, b5 = {
  fill: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
};
function P5(t, n, o, i, C, s) {
  return r(), l("svg", b5, n[0] || (n[0] = [
    e("path", {
      "clip-rule": "evenodd",
      "fill-rule": "evenodd",
      d: "M9.315 7.584C12.195 3.883 16.695 1.5 21.75 1.5a.75.75 0 01.75.75c0 5.056-2.383 9.555-6.084 12.436A6.75 6.75 0 019.75 22.5a.75.75 0 01-.75-.75v-4.131A15.838 15.838 0 016.382 15H2.25a.75.75 0 01-.75-.75 6.75 6.75 0 017.815-6.666zM15 6.75a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z"
    }, null, -1),
    e("path", { d: "M5.26 17.242a.75.75 0 10-.897-1.203 5.243 5.243 0 00-2.05 5.022.75.75 0 00.625.627 5.243 5.243 0 005.022-2.051.75.75 0 10-1.202-.897 3.744 3.744 0 01-3.008 1.51c0-1.23.592-2.323 1.51-3.008z" }, null, -1)
  ]));
}
const R5 = /* @__PURE__ */ c(V5, [["render", P5]]), N5 = {
  name: "Swatch"
}, D5 = {
  fill: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
};
function E5(t, n, o, i, C, s) {
  return r(), l("svg", D5, n[0] || (n[0] = [
    e("path", {
      "clip-rule": "evenodd",
      "fill-rule": "evenodd",
      d: "M2.25 4.125c0-1.036.84-1.875 1.875-1.875h5.25c1.036 0 1.875.84 1.875 1.875V17.25a4.5 4.5 0 11-9 0V4.125zm4.5 14.25a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25z"
    }, null, -1),
    e("path", { d: "M10.719 21.75h9.156c1.036 0 1.875-.84 1.875-1.875v-5.25c0-1.036-.84-1.875-1.875-1.875h-.14l-8.742 8.743c-.09.089-.18.175-.274.257zM12.738 17.625l6.474-6.474a1.875 1.875 0 000-2.651L15.5 4.787a1.875 1.875 0 00-2.651 0l-.1.099V17.25c0 .126-.003.251-.01.375z" }, null, -1)
  ]));
}
const U5 = /* @__PURE__ */ c(N5, [["render", E5]]), j5 = {
  name: "SquaresGrid"
}, T5 = {
  fill: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
};
function q5(t, n, o, i, C, s) {
  return r(), l("svg", T5, n[0] || (n[0] = [
    e("path", {
      "clip-rule": "evenodd",
      "fill-rule": "evenodd",
      d: "M3 6a3 3 0 013-3h2.25a3 3 0 013 3v2.25a3 3 0 01-3 3H6a3 3 0 01-3-3V6zm9.75 0a3 3 0 013-3H18a3 3 0 013 3v2.25a3 3 0 01-3 3h-2.25a3 3 0 01-3-3V6zM3 15.75a3 3 0 013-3h2.25a3 3 0 013 3V18a3 3 0 01-3 3H6a3 3 0 01-3-3v-2.25zm9.75 0a3 3 0 013-3H18a3 3 0 013 3V18a3 3 0 01-3 3h-2.25a3 3 0 01-3-3v-2.25z"
    }, null, -1)
  ]));
}
const G5 = /* @__PURE__ */ c(j5, [["render", q5]]), O5 = {
  name: "ServerStack"
}, J5 = {
  fill: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
};
function W5(t, n, o, i, C, s) {
  return r(), l("svg", J5, n[0] || (n[0] = [
    e("path", { d: "M5.507 4.048A3 3 0 017.785 3h8.43a3 3 0 012.278 1.048l1.722 2.008A4.533 4.533 0 0019.5 6h-15c-.243 0-.482.02-.715.056l1.722-2.008z" }, null, -1),
    e("path", {
      "clip-rule": "evenodd",
      "fill-rule": "evenodd",
      d: "M1.5 10.5a3 3 0 013-3h15a3 3 0 110 6h-15a3 3 0 01-3-3zm15 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm2.25.75a.75.75 0 100-1.5.75.75 0 000 1.5zM4.5 15a3 3 0 100 6h15a3 3 0 100-6h-15zm11.25 3.75a.75.75 0 100-1.5.75.75 0 000 1.5zM19.5 18a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"
    }, null, -1)
  ]));
}
const K5 = /* @__PURE__ */ c(O5, [["render", W5]]), Q5 = {
  name: "ArrowsExpand"
}, X5 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Y5(t, n, o, i, C, s) {
  return r(), l("svg", X5, n[0] || (n[0] = [
    e("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0.807693 10.7071C0.417168 10.3166 0.417168 9.68342 0.807693 9.29289L3.63612 6.46447C4.02664 6.07394 4.65981 6.07394 5.05033 6.46447C5.44086 6.85499 5.44086 7.48816 5.05033 7.87868L3.92901 9L7.17165 9C7.72394 9 8.17165 9.44772 8.17165 10C8.17165 10.5523 7.72394 11 7.17165 11L3.92901 11L5.05033 12.1213C5.44086 12.5118 5.44086 13.145 5.05033 13.5355C4.65981 13.9261 4.02664 13.9261 3.63612 13.5355L0.807693 10.7071ZM14.9498 6.46447C15.3404 6.07394 15.9735 6.07394 16.364 6.46447L19.1925 9.29289C19.583 9.68342 19.583 10.3166 19.1925 10.7071L16.364 13.5355C15.9735 13.9261 15.3404 13.9261 14.9498 13.5355C14.5593 13.145 14.5593 12.5118 14.9498 12.1213L16.0711 11H12.8285C12.2762 11 11.8285 10.5523 11.8285 10C11.8285 9.44772 12.2762 9 12.8285 9H16.0711L14.9498 7.87868C14.5593 7.48816 14.5593 6.85499 14.9498 6.46447Z",
      fill: "currentColor"
    }, null, -1)
  ]));
}
const n0 = /* @__PURE__ */ c(Q5, [["render", Y5]]), e0 = {
  name: "GooglePlay"
}, t0 = {
  viewBox: "0 0 20 20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
function o0(t, n, o, i, C, s) {
  return r(), l("svg", t0, n[0] || (n[0] = [
    e("path", { d: "M12.4516 9.32331L6.23403 2.40633L14.1447 7.44481L12.4516 9.32331V9.32331ZM4.61133 2C4.2451 2.21254 4 2.60012 4 3.10334V16.8967C4 17.3999 4.2451 17.7875 4.61133 18L11.8402 9.99844L4.61133 2ZM16.59 9.05138L14.9307 7.98554L13.0798 10.0016L14.9307 12.0176L16.6238 10.9517C17.1309 10.5048 17.1309 9.49834 16.59 9.05138V9.05138ZM6.23403 17.5968L14.1447 12.5583L12.4516 10.6798L6.23403 17.5968Z" }, null, -1)
  ]));
}
const r0 = /* @__PURE__ */ c(e0, [["render", o0]]), s0 = {
  name: "Apple"
}, l0 = {
  viewBox: "0 0 20 20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
function i0(t, n, o, i, C, s) {
  return r(), l("svg", l0, n[0] || (n[0] = [
    e("path", { d: "M13.9594 10.3969C13.9531 9.25 14.4719 8.38438 15.5219 7.74688C14.9344 6.90625 14.0469 6.44375 12.875 6.35313C11.7656 6.26563 10.5531 7 10.1094 7C9.64062 7 8.56562 6.38438 7.72187 6.38438C5.97812 6.4125 4.125 7.775 4.125 10.5469C4.125 11.3656 4.275 12.2115 4.575 13.0844C4.975 14.2313 6.41875 17.0438 7.925 16.9969C8.7125 16.9781 9.26875 16.4375 10.2937 16.4375C11.2875 16.4375 11.8031 16.9969 12.6812 16.9969C14.2 16.975 15.5062 14.4188 15.8875 13.2688C13.85 12.3094 13.9594 10.4563 13.9594 10.3969V10.3969ZM12.1906 5.26563C13.0438 4.25313 12.9656 3.33125 12.9406 3C12.1875 3.04375 11.3156 3.5125 10.8187 4.09063C10.2719 4.70938 9.95 5.475 10.0188 6.3375C10.8344 6.4 11.5781 5.98125 12.1906 5.26563V5.26563Z" }, null, -1)
  ]));
}
const C0 = /* @__PURE__ */ c(s0, [["render", i0]]), c0 = {
  name: "ArrowUpSmall"
}, a0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
function d0(t, n, o, i, C, s) {
  return r(), l("svg", a0, n[0] || (n[0] = [
    e("path", {
      "fill-rule": "evenodd",
      d: "M10 15a.75.75 0 01-.75-.75V7.612L7.29 9.77a.75.75 0 01-1.08-1.04l3.25-3.5a.75.75 0 011.08 0l3.25 3.5a.75.75 0 11-1.08 1.04l-1.96-2.158v6.638A.75.75 0 0110 15z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const u0 = /* @__PURE__ */ c(c0, [["render", d0]]), p0 = {
  name: "ArrowDownSmall"
}, $0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
function f0(t, n, o, i, C, s) {
  return r(), l("svg", $0, n[0] || (n[0] = [
    e("path", {
      "fill-rule": "evenodd",
      d: "M10 5a.75.75 0 01.75.75v6.638l1.96-2.158a.75.75 0 111.08 1.04l-3.25 3.5a.75.75 0 01-1.08 0l-3.25-3.5a.75.75 0 111.08-1.04l1.96 2.158V5.75A.75.75 0 0110 5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const _0 = /* @__PURE__ */ c(p0, [["render", f0]]), h0 = {
  name: "Leads"
}, v0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
};
function L0(t, n, o, i, C, s) {
  return r(), l("svg", v0, n[0] || (n[0] = [
    e("path", { d: "M4.5 6.375a4.125 4.125 0 118.25 0 4.125 4.125 0 01-8.25 0zM14.25 8.625a3.375 3.375 0 116.75 0 3.375 3.375 0 01-6.75 0zM1.5 19.125a7.125 7.125 0 0114.25 0v.003l-.001.119a.75.75 0 01-.363.63 13.067 13.067 0 01-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 01-.364-.63l-.001-.122zM17.25 19.128l-.001.144a2.25 2.25 0 01-.233.96 10.088 10.088 0 005.06-1.01.75.75 0 00.42-.643 4.875 4.875 0 00-6.957-4.611 8.586 8.586 0 011.71 5.157v.003z" }, null, -1)
  ]));
}
const m0 = /* @__PURE__ */ c(h0, [["render", L0]]), w0 = {
  name: "Comms"
}, g0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
};
function x0(t, n, o, i, C, s) {
  return r(), l("svg", g0, n[0] || (n[0] = [
    e("path", { d: "M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.928 5.493a3 3 0 01-3.144 0L1.5 8.67z" }, null, -1),
    e("path", { d: "M22.5 6.908V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.158l9.714 5.978a1.5 1.5 0 001.572 0L22.5 6.908z" }, null, -1)
  ]));
}
const M0 = /* @__PURE__ */ c(w0, [["render", x0]]), z0 = {
  name: "Events"
}, Z0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
};
function B0(t, n, o, i, C, s) {
  return r(), l("svg", Z0, n[0] || (n[0] = [
    e("path", {
      "fill-rule": "evenodd",
      d: "M1.5 6.375c0-1.036.84-1.875 1.875-1.875h17.25c1.035 0 1.875.84 1.875 1.875v3.026a.75.75 0 01-.375.65 2.249 2.249 0 000 3.898.75.75 0 01.375.65v3.026c0 1.035-.84 1.875-1.875 1.875H3.375A1.875 1.875 0 011.5 17.625v-3.026a.75.75 0 01.374-.65 2.249 2.249 0 000-3.898.75.75 0 01-.374-.65V6.375zm15-1.125a.75.75 0 01.75.75v.75a.75.75 0 01-1.5 0V6a.75.75 0 01.75-.75zm.75 4.5a.75.75 0 00-1.5 0v.75a.75.75 0 001.5 0v-.75zm-.75 3a.75.75 0 01.75.75v.75a.75.75 0 01-1.5 0v-.75a.75.75 0 01.75-.75zm.75 4.5a.75.75 0 00-1.5 0V18a.75.75 0 001.5 0v-.75zM6 12a.75.75 0 01.75-.75H12a.75.75 0 010 1.5H6.75A.75.75 0 016 12zm.75 2.25a.75.75 0 000 1.5h3a.75.75 0 000-1.5h-3z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const F0 = /* @__PURE__ */ c(z0, [["render", B0]]), I0 = {
  name: "Bookings"
}, y0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
};
function k0(t, n, o, i, C, s) {
  return r(), l("svg", y0, n[0] || (n[0] = [
    e("path", { d: "M12.75 12.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM7.5 15.75a.75.75 0 100-1.5.75.75 0 000 1.5zM8.25 17.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM9.75 15.75a.75.75 0 100-1.5.75.75 0 000 1.5zM10.5 17.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM12 15.75a.75.75 0 100-1.5.75.75 0 000 1.5zM12.75 17.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM14.25 15.75a.75.75 0 100-1.5.75.75 0 000 1.5zM15 17.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM16.5 15.75a.75.75 0 100-1.5.75.75 0 000 1.5zM15 12.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM16.5 13.5a.75.75 0 100-1.5.75.75 0 000 1.5z" }, null, -1),
    e("path", {
      "fill-rule": "evenodd",
      d: "M6.75 2.25A.75.75 0 017.5 3v1.5h9V3A.75.75 0 0118 3v1.5h.75a3 3 0 013 3v11.25a3 3 0 01-3 3H5.25a3 3 0 01-3-3V7.5a3 3 0 013-3H6V3a.75.75 0 01.75-.75zm13.5 9a1.5 1.5 0 00-1.5-1.5H5.25a1.5 1.5 0 00-1.5 1.5v7.5a1.5 1.5 0 001.5 1.5h13.5a1.5 1.5 0 001.5-1.5v-7.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const A0 = /* @__PURE__ */ c(I0, [["render", k0]]), H0 = {
  name: "Reports"
}, S0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
};
function V0(t, n, o, i, C, s) {
  return r(), l("svg", S0, n[0] || (n[0] = [
    e("path", {
      "fill-rule": "evenodd",
      d: "M2.25 13.5a8.25 8.25 0 018.25-8.25.75.75 0 01.75.75v6.75H18a.75.75 0 01.75.75 8.25 8.25 0 01-16.5 0z",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      "fill-rule": "evenodd",
      d: "M12.75 3a.75.75 0 01.75-.75 8.25 8.25 0 018.25 8.25.75.75 0 01-.75.75h-7.5a.75.75 0 01-.75-.75V3z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const b0 = /* @__PURE__ */ c(H0, [["render", V0]]), P0 = {
  name: "Forms"
}, R0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  class: "w-6 h-6"
};
function N0(t, n, o, i, C, s) {
  return r(), l("svg", R0, n[0] || (n[0] = [
    e("path", {
      "fill-rule": "evenodd",
      d: "M5.625 1.5c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0016.5 9h-1.875a1.875 1.875 0 01-1.875-1.875V5.25A3.75 3.75 0 009 1.5H5.625zM7.5 15a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5A.75.75 0 017.5 15zm.75 2.25a.75.75 0 000 1.5H12a.75.75 0 000-1.5H8.25z",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", { d: "M12.971 1.816A5.23 5.23 0 0114.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 013.434 1.279 9.768 9.768 0 00-6.963-6.963z" }, null, -1)
  ]));
}
const D0 = /* @__PURE__ */ c(P0, [["render", N0]]), E0 = {
  name: "Automations"
}, U0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  class: "w-6 h-6"
};
function j0(t, n, o, i, C, s) {
  return r(), l("svg", U0, n[0] || (n[0] = [
    e("path", { d: "M5.055 7.06c-1.25-.714-2.805.189-2.805 1.628v8.123c0 1.44 1.555 2.342 2.805 1.628L12 14.471v2.34c0 1.44 1.555 2.342 2.805 1.628l7.108-4.061c1.26-.72 1.26-2.536 0-3.256L14.805 7.06C13.555 6.346 12 7.25 12 8.688v2.34L5.055 7.06z" }, null, -1)
  ]));
}
const T0 = /* @__PURE__ */ c(E0, [["render", j0]]), q0 = {
  name: "Settings"
}, G0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
};
function O0(t, n, o, i, C, s) {
  return r(), l("svg", G0, n[0] || (n[0] = [
    e("path", {
      "fill-rule": "evenodd",
      d: "M11.828 2.25c-.916 0-1.699.663-1.85 1.567l-.091.549a.798.798 0 01-.517.608 7.45 7.45 0 00-.478.198.798.798 0 01-.796-.064l-.453-.324a1.875 1.875 0 00-2.416.2l-.243.243a1.875 1.875 0 00-.2 2.416l.324.453a.798.798 0 01.064.796 7.448 7.448 0 00-.198.478.798.798 0 01-.608.517l-.55.092a1.875 1.875 0 00-1.566 1.849v.344c0 .916.663 1.699 1.567 1.85l.549.091c.281.047.508.25.608.517.06.162.127.321.198.478a.798.798 0 01-.064.796l-.324.453a1.875 1.875 0 00.2 2.416l.243.243c.648.648 1.67.733 2.416.2l.453-.324a.798.798 0 01.796-.064c.157.071.316.137.478.198.267.1.47.327.517.608l.092.55c.15.903.932 1.566 1.849 1.566h.344c.916 0 1.699-.663 1.85-1.567l.091-.549a.798.798 0 01.517-.608 7.52 7.52 0 00.478-.198.798.798 0 01.796.064l.453.324a1.875 1.875 0 002.416-.2l.243-.243c.648-.648.733-1.67.2-2.416l-.324-.453a.798.798 0 01-.064-.796c.071-.157.137-.316.198-.478.1-.267.327-.47.608-.517l.55-.091a1.875 1.875 0 001.566-1.85v-.344c0-.916-.663-1.699-1.567-1.85l-.549-.091a.798.798 0 01-.608-.517 7.507 7.507 0 00-.198-.478.798.798 0 01.064-.796l.324-.453a1.875 1.875 0 00-.2-2.416l-.243-.243a1.875 1.875 0 00-2.416-.2l-.453.324a.798.798 0 01-.796.064 7.462 7.462 0 00-.478-.198.798.798 0 01-.517-.608l-.091-.55a1.875 1.875 0 00-1.85-1.566h-.344zM12 15.75a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const J0 = /* @__PURE__ */ c(q0, [["render", O0]]), W0 = {
  name: "Payment"
}, K0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
};
function Q0(t, n, o, i, C, s) {
  return r(), l("svg", K0, n[0] || (n[0] = [
    e("path", { d: "M4.5 3.75a3 3 0 00-3 3v.75h21v-.75a3 3 0 00-3-3h-15z" }, null, -1),
    e("path", {
      "fill-rule": "evenodd",
      d: "M22.5 9.75h-21v7.5a3 3 0 003 3h15a3 3 0 003-3v-7.5zm-18 3.75a.75.75 0 01.75-.75h6a.75.75 0 010 1.5h-6a.75.75 0 01-.75-.75zm.75 2.25a.75.75 0 000 1.5h3a.75.75 0 000-1.5h-3z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const X0 = /* @__PURE__ */ c(W0, [["render", Q0]]), _ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AppleIcon: C0,
  ArrowDownSmallIcon: _0,
  ArrowUpSmallIcon: u0,
  ArrowsExpandIcon: n0,
  AutomationsIcon: T0,
  BoldIcon: J1,
  BookingsIcon: A0,
  BranchIcon: r1,
  CenterAlignIcon: a5,
  CheckSquareIcon: K,
  CheckboxIcon: F1,
  CommsIcon: M0,
  DotIcon: _1,
  DotsMoveIcon: G,
  EventsIcon: F0,
  FormsIcon: D0,
  GooglePlayIcon: r0,
  ItalicsIcon: X1,
  LeadsIcon: m0,
  LeftAlignIcon: l5,
  LoadIcon: S,
  MultilineIcon: A1,
  NumberIcon: u1,
  OrderedListIcon: g5,
  PaymentIcon: X0,
  PercentIcon: m1,
  PinnedIcon: R,
  PlusOutlineIcon: Z5,
  PlusSolidIcon: y5,
  RadioCircleIcon: b1,
  ReportsIcon: b0,
  RestoreIcon: U,
  RightAlignIcon: $5,
  RingIcon: S5,
  RocketLaunchIcon: R5,
  ServerStackIcon: K5,
  SettingsIcon: J0,
  SignatureIcon: D1,
  SinglelineIcon: T1,
  SquaresGridIcon: G5,
  SwatchIcon: U5,
  TimerIcon: n1,
  TokenIcon: C1,
  UnderlineIcon: t5,
  UnorderedListIcon: v5,
  WaveIcon: M1
}, Symbol.toStringTag, { value: "Module" })), l7 = {
  __name: "DIcon",
  props: {
    icon: {
      type: String,
      default: "",
      description: 'Iconify icon, format should be "set:icon" (e.g. heroicons:chevron-down-16-solid)',
      iconify: !0
    },
    iconSet: {
      type: String,
      default: "heroicons",
      description: "Name of the icon set.",
      deprecated: "Use icon prop with full iconify icon string"
    },
    type: {
      type: String,
      default: "",
      description: "Type of icon",
      deprecated: "Use icon prop with full iconify icon string"
    },
    indicator: {
      type: Boolean,
      default: !1,
      description: "Display a notification indicator on the icon."
    },
    indicatorColor: {
      type: String,
      default: "destructive",
      description: "The color for the notification indicator",
      validator(t) {
        return [
          "destructive",
          "brand",
          "accent"
        ].includes(t);
      }
    },
    indicatorNumber: {
      type: [String, Number],
      default: null,
      description: "Displays a number instead of a dot for the indicator"
    },
    indicatorBorder: {
      type: Boolean,
      default: !0,
      description: "Display a border around the icon"
    },
    spin: {
      type: Boolean,
      default: !1,
      description: "Spin the icon."
    },
    pin: {
      type: Boolean,
      default: !1,
      description: "Pin the icon to the left or right side of the container."
    },
    position: {
      type: String,
      default: "left",
      description: "Position of the icon (left or right).",
      validator(t) {
        return [
          "left",
          "right"
        ].includes(t);
      }
    },
    size: {
      type: String,
      description: "Size of the icon using tailwind w/h classes (e.g. w-5 h-5)"
    },
    force: {
      type: Boolean,
      default: !1,
      description: "Forces icon to use iconify if custom icon also matches."
    }
  },
  setup(t) {
    const n = {
      sm: "w-5 h-5",
      base: "w-6 h-6"
    }, o = t, i = d(() => Z(o.iconSet, o.icon, o.type)), C = d(() => B(o.icon)), s = d(() => {
      if (o.size)
        return o.size;
      switch (o.type) {
        case "small":
          return n.sm;
        case "outline":
        case "solid":
        case "custom":
        default:
          return n.base;
      }
    }), p = d(() => `${F(I(C.value))}Icon`), h = d(() => o.force ? !1 : y(_).includes(p.value)), v = d(() => {
      switch (o.indicatorColor) {
        case "destructive":
        default:
          return "bg-(--shape-destructive-base)";
        case "brand":
          return "bg-(--shape-brand-base)";
        case "accent":
          return "bg-(--shape-brand-accent)";
      }
    }), L = d(() => {
      switch (o.position) {
        case "right":
          return "right-0";
        case "left":
        default:
          return "left-0";
      }
    }), m = d(() => o.pin ? "absolute px-3" : "relative");
    return (Y0, n7) => (r(), l("div", {
      class: u(["inset-y-0 flex items-center pointer-events-none", [a(L), a(m)]]),
      "data-spark": "dicon"
    }, [
      a(h) ? (r(), $(w(_[a(p)]), {
        key: 1,
        class: u([
          a(s),
          {
            "animate-spin": t.spin
          }
        ])
      }, null, 8, ["class"])) : (r(), $(a(z), {
        key: 0,
        "data-cy": "icon",
        icon: a(i),
        class: u([
          a(s),
          {
            "animate-spin": t.spin
          }
        ]),
        ssr: ""
      }, null, 8, ["icon", "class"])),
      t.indicator ? (r(), l("div", {
        key: 2,
        class: u(["absolute rounded-full z-10 text-neutral-on-invert flex items-center justify-center", [a(v), {
          "w-5 h-5 button-xs text-[12px] leading-4": t.indicatorNumber,
          "w-2 h-2 rounded-full z-10 right-0 top-0 ": !t.indicatorNumber,
          "ring ring-(--base-surface-default)": t.indicatorNumber && t.indicatorBorder,
          "-right-2.5 -top-2.5": t.indicatorNumber && a(s) !== n.base,
          "-right-2 -top-2": t.indicatorNumber && a(s) === n.base
        }]])
      }, [
        t.indicatorNumber ? (r(), l(g, { key: 0 }, [
          x(M(t.indicatorNumber), 1)
        ], 64)) : f("", !0)
      ], 2)) : f("", !0)
    ], 2));
  }
};
export {
  l7 as _
};
